<template>
  <div class="solution">
    <Header />
    <Navigation />
    <!-- 应用场景 -->
    <ApplicationScenario />
    <!-- 远程银行 -->
    <RemoteBank />
    <!-- 数字人客服 -->
    <DigitalCustomerService />
    <!-- 呼叫中心 -->
    <CallCenter />
    <!-- 医疗设备 -->
    <MedicalEquipment />
    <!-- 其他场景 -->
    <OtherScenes />
    <!-- 系统功能 -->
    <SystemFunction />
    <!-- 方案优势 -->
    <SchemeAdvantages />
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import Navigation from "@/components/Solution/Navigation";
  import ApplicationScenario from "@/components/Solution/ApplicationScenario.vue";
  import RemoteBank from "@/components/Solution/RemoteBank.vue";
  import DigitalCustomerService from "@/components/Solution/DigitalCustomerService.vue";
  import CallCenter from "@/components/Solution/CallCenter.vue";
  import OtherScenes from "@/components/Solution/OtherScenes.vue";
  import SystemFunction from "@/components/Solution/SystemFunction.vue";
  import SchemeAdvantages from "@/components/Solution/SchemeAdvantages.vue";
  import Footer from "@/components/Footer.vue";
  import MedicalEquipment from "@/components/Solution/MedicalEquipment.vue";
  export default {
    name: "",
    components: {
      Header,
      Navigation,
      ApplicationScenario,
      RemoteBank,
      DigitalCustomerService,
      CallCenter,
      OtherScenes,
      SystemFunction,
      SchemeAdvantages,
      Footer,
      MedicalEquipment,
    },
    props: {},
  };
</script>

<style lang="scss" scoped>
  .solution {
    background-color: $bg-color;
    overflow-x: hidden;
  }
</style>
